export default {
  getName: state => state.name,
  getActive: state => state.active
}
